import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
// import { forEach } from 'lodash';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LoaderService implements HttpInterceptor {

  constructor() { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const loaderKey = req.body?.loader; // Safely access req.body.loader
    if (loaderKey) {
      const _loader = Array.from(
        document.querySelectorAll<HTMLElement>(
          `.fc-dynamic-${loaderKey}, .fc-dynamic-${loaderKey}-bg-load`
        )
      );

      _loader.forEach((ele) => {
        if (ele.classList.contains(`fc-dynamic-${loaderKey}`)) {
          ele.style.display = 'flex';
        }
        if (ele.classList.contains(`fc-dynamic-${loaderKey}-bg-load`)) {
          ele.style.filter = 'brightness(0.9)';
        }
      });
    }

    return next.handle(req).pipe(
      finalize(() => {
        if (loaderKey) {
          const _loader = Array.from(
            document.querySelectorAll<HTMLElement>(
              `.fc-dynamic-${loaderKey}, .fc-dynamic-${loaderKey}-bg-load`
            )
          );

          _loader.forEach((ele) => {
            if (ele.classList.contains(`fc-dynamic-${loaderKey}`)) {
              ele.style.display = 'none';
            }
            if (ele.classList.contains(`fc-dynamic-${loaderKey}-bg-load`)) {
              ele.style.filter = 'none';
            }
          });
        }
      })
    )
  }
}
